import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

interface Step {
    text: string;
    href: string;
    rangeClass?: string;
    strokeWidth?: number;
}

interface PageNavLeftProps {
    steps: Step[];
    triggerElement: string; // 触发动画的元素
    // 触发进入动画元素
    enterElement?: string;

    // 会触发切换主题的多个
    triggerElements?: {
        selectors: string;
        theme: Theme;
    }[];

    isUs?: boolean;
}

export enum Theme {
    white = 'white',
    black = 'black',
}

const PageNavLeft: React.FC<PageNavLeftProps> = ({ steps, triggerElement = '', enterElement = '#SectionA', triggerElements = [], isUs = true }) => {
    const [active, setActive] = useState(0);
    const [process, setProcess] = useState(100);
    const [theme, setTheme] = useState<Theme>(Theme.white);
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                steps.forEach((step, index) => {
                    const rangeClass = step.rangeClass || `range${index + 1}`;
                    let rangeDom = document.querySelector(`${triggerElement} .${rangeClass}`) as HTMLDivElement;

                    if (rangeDom) {
                        let rangeHeight = rangeDom.offsetHeight;
                        if (index === 0 && isUs) {
                            // 获取onePicture的高和和range1的高度
                            const onePicture = document.getElementById('OnePicture') as HTMLDivElement;
                            if (onePicture) {
                                rangeHeight += onePicture.offsetHeight + 400;
                            }
                            rangeDom = onePicture;
                        }
                        const sceneProcess = AniContainer.create({
                            triggerElement: rangeDom,
                            triggerHook: 1,
                            duration: rangeHeight,
                            offset: isUs ? '0%' : '30%',
                            onEnter: () => setActive(index),
                            onProcess: (rate: number) => setProcess(100 * (1 - rate)),
                        });

                        return () => sceneProcess.destroy();
                    }
                });
            }, 1000);
        }
    }, [steps, triggerElement]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const callback = () => {
                    const target: HTMLElement | null = document.querySelector(enterElement) as HTMLDivElement;
                    if (target) {
                        const { top, height } = target.getBoundingClientRect();
                        const flag = top - height / 2;
                        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                        if (scrollTop > flag) {
                            setEnter(true);
                        } else {
                            setEnter(false);
                        }
                    }
                };
                // 监听滚动条事件
                window.addEventListener('scroll', callback);
                return () => window.removeEventListener('scroll', callback);
            }, 1000);
        }
    }, [enterElement]);

    useEffect(() => {
        if (!triggerElements || triggerElements.length === 0 || typeof window === 'undefined') return;
        const targets = new WeakMap<HTMLElement, Theme>();
        const themeSwitchObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const target = entry.target as HTMLElement;
                    if (targets.has(target)) {
                        const theme = targets.get(target) as Theme;
                        if (entry.isIntersecting) {
                            setTheme(theme);
                        }
                    }
                });
            },
            {
                threshold: 0.3,
            },
        );
        try {
            triggerElements.forEach((item) => {
                const element = document.querySelector(item.selectors) as HTMLElement;
                if (element) {
                    targets.set(element, item.theme);
                    themeSwitchObserver.observe(element);
                }
            });
        } catch (error) {}

        return () => {
            themeSwitchObserver.disconnect();
        };
    }, [triggerElements]);

    return (
        <div className={`${css.progress} ${enter ? 'enter' : ''}`}>
            {steps?.map((step, index) => (
                <EcoLink
                    key={index}
                    className={`pro-item GtmModuleData-btn-common pro-item-${index + 1} ${theme} ${active === index ? 'active' : ''}`}
                    data-btn-id={step.text}
                    dataLayer={(() => {
                        let title = 'none';
                        if (typeof window !== 'undefined') {
                            title =
                                document?.querySelector(`${step.href} .eco-title`)?.innerHTML ??
                                document?.querySelector(`${step.href} .eco-section-title`)?.innerHTML ??
                                'none';
                        }
                        return {
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            list_name: title,
                            button_name: step.text,
                            __btn_id1: `${css.progress} .pro-item-${index + 1}`,
                            __btn_id2: step.text,
                            __btn_type: 'common',
                        };
                    })()}
                    href={step.href}
                >
                    {active === index && (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {/* 背景圆环 */}
                            <circle cx="8" cy="8" r="7" stroke="var(--progress-theme)" strokeOpacity="0.2" strokeWidth="2" />
                            {/* 动画进度圆环 */}
                            <circle
                                cx="8"
                                cy="8"
                                r="7"
                                stroke="#fff"
                                strokeWidth="2"
                                strokeDasharray="44" // 圆的总长度（2πr，近似为 2 * 3.14 * 7 = 44）
                                strokeDashoffset={(process / 100) * 44} // 初始值，完全不显示
                                transform="rotate(-90 8 8)"
                            />
                        </svg>
                    )}
                    <span className={`item-name ${active === index ? 'active' : ''}`}>{step.text}</span>
                </EcoLink>
            ))}
        </div>
    );
};

export default PageNavLeft;
